export const isRelease = true; //打开它 true 则打包是发上生产
let MINGYUAN_PHURCHASE_BASE_URL = "https://test-api-cgmh-api.yazhou-szkx.com:8443/bms/index.php?r=CzSupplier/api/login/yzw-sso&tenant_code=yzbstctest&target_url="; // Test环境
if(process.env.NODE_ENV === 'production'&&isRelease){
    MINGYUAN_PHURCHASE_BASE_URL = "https://api-cgmh-api.yazhou-szkx.com:9443/bms/index.php?r=CzSupplier/api/login/yzw-sso&tenant_code=yzbstc&target_url="; //生产环境
}

const CONSTANTS_OBJ = {
    MINGYUAN_PHURCHASE_BASE_URL,
}
// code=MvbrmTy4WxmD-KIorBZZloeHcFx5dII9JCueYTR-0lO

export const Jump_Ming_Yuan = (windowobj, url, withUrl = false, _target="_blank") => {
    if(!windowobj){
        return console.log("window对象为空");
    }
    if(!url){
        return console.log("目标链接为空");
    }
    if(withUrl){
        return windowobj.open(CONSTANTS_OBJ.MINGYUAN_PHURCHASE_BASE_URL + url, _target)
    }
    return windowobj.open(url, _target)
}



// WEBPACK FOOTER //
// ./src/constants/index.js